<template>
  <el-icon :size="size" :color="color">
    <svg :class="['c-icon', `icon-${name}`, className]" aria-hidden="true">
      <use :xlink:href="`#icon-${name}`"></use>
    </svg>
  </el-icon>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  /** 图标名称 */
  name: string
  /** 图标大小 */
  size?: number | string
  /** 图标颜色 */
  color?: string
  /** 额外的CSS类名 */
  className?: string
}>(), {
  color: 'currentColor'
})
</script>

<style scoped>
.c-icon {
   width: 1em; height: 1em;
   vertical-align: -0.15em;
   fill: currentColor;
   overflow: hidden;
}
</style>